import React, { useEffect, useRef } from 'react'
import Navbar from '../Navbar'

function BookFlightCom() {
    const iframeRef = useRef<HTMLIFrameElement>(null);
    const spinnerRef = useRef<HTMLDivElement>(null);

    const IFRAME_ID = 'travelstartIframe-2eee0194-5096-4d35-bdd9-61c3e6857dea';
    const IFRAME_URL = 'https://www.travelstart.com.ng';
    const AFF_ID = '221743';
    const AFF_CAMPAIGN = 'Default';
    const AFF_CURRENCY = 'NGN'; // Changed from Default to NGN for Nigerian users
    const IFRAME_VERSION = '11';
    const SHOW_BANNERS = false;
    const LOG_MESSAGES = false;
    const LANGUAGE = '';

    useEffect(() => {
        const iframe = iframeRef.current;
        if (!iframe) return;

        // Parse existing URL params from the host page
        const urlParams: Record<string, string> = {};
        const query = window.location.search.substring(1);
        const search = /([^&=]+)=?([^&]*)/g;
        const pl = /\+/g;
        const decode = (s: string) => decodeURIComponent(s.replace(pl, ' '));
        let match;
        while ((match = search.exec(query))) {
            urlParams[decode(match[1])] = decode(match[2]);
        }

        // Build iframe params
        const iframeParams: string[] = [];
        const alreadyExist = Object.keys(urlParams);
        let affiliateIdExist = false;

        for (const key in urlParams) {
            if (key === 'affId' || key === 'affid' || key === 'aff_id') {
                affiliateIdExist = true;
            }
            iframeParams.push(`${key}=${urlParams[key]}`);
        }

        if (!alreadyExist.includes('show_banners')) iframeParams.push(`show_banners=${SHOW_BANNERS}`);
        if (!alreadyExist.includes('log')) iframeParams.push(`log=${LOG_MESSAGES}`);
        if (!affiliateIdExist) iframeParams.push(`affId=${AFF_ID}`);
        if (!affiliateIdExist) iframeParams.push(`language=${LANGUAGE}`);
        if (!alreadyExist.includes('affCampaign')) iframeParams.push(`affCampaign=${AFF_CAMPAIGN}`);
        if (!alreadyExist.includes('utm_source')) iframeParams.push('utm_source=affiliate');
        if (!alreadyExist.includes('utm_medium')) iframeParams.push(`utm_medium=${AFF_ID}`);
        if (!alreadyExist.includes('isiframe')) iframeParams.push('isiframe=true');
        if (!alreadyExist.includes('landing_page')) iframeParams.push('landing_page=false');
        if (AFF_CURRENCY.length === 3) iframeParams.push(`currency=${AFF_CURRENCY}`);
        if (!alreadyExist.includes('iframeVersion')) iframeParams.push(`iframeVersion=${IFRAME_VERSION}`);
        if (!alreadyExist.includes('host')) iframeParams.push(`host=${window.location.href.split('?')[0]}`);

        const newSrc = `${IFRAME_URL}/?search=false&${iframeParams.join('&')}`;
        iframe.src = newSrc;

        // Hide spinner on ready
        const hideSpinner = () => {
            if (spinnerRef.current) spinnerRef.current.style.display = 'none';
        };
        iframe.addEventListener('load', hideSpinner);

        // Listen for postMessage height updates from Travelstart
        const handleMessage = (e: MessageEvent) => {
            if (!Array.isArray(e.data)) return;
            const [eventName, data] = e.data;
            if (eventName === 'setHeight' && iframe) {
                iframe.style.height = `${data}px`;
            }
        };
        window.addEventListener('message', handleMessage);

        return () => {
            iframe.removeEventListener('load', hideSpinner);
            window.removeEventListener('message', handleMessage);
        };
    }, []);

    return (
        <>
            <style>{`
                @keyframes spinner {
                    0% { transform: translate3d(-50%, -50%, 0) rotate(0deg); }
                    100% { transform: translate3d(-50%, -50%, 0) rotate(360deg); }
                }
                .ts-spinner::before {
                    animation: 1.5s linear infinite spinner;
                    border: solid 5px #cfd0d1;
                    border-bottom-color: #209D5A;
                    border-radius: 50%;
                    content: '';
                    height: 40px;
                    width: 40px;
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate3d(-50%, -50%, 0);
                    will-change: transform;
                }
                .ts-iframe {
                    width: 100%;
                    min-height: 100vh;
                    border: none;
                    display: block;
                }
            `}</style>

            <Navbar />

            <div className="relative px-8 lg:px-16 pb-6 pt-6 lg:pt-20">
                {/* Spinner */}
                <div
                    ref={spinnerRef}
                    className="ts-spinner"
                    style={{ position: 'relative', height: '60px' }}
                />

                {/* Travelstart iframe — NO sandbox attribute */}
                <iframe
                    ref={iframeRef}
                    id={IFRAME_ID}
                    className="ts-iframe"
                    frameBorder={0}
                    scrolling="auto"
                    style={{ height: '0px', backgroundColor: '#fafafa' }}
                    title="Book a Flight"
                />
            </div>
        </>
    );
}

export default BookFlightCom;